/**
 * @generated SignedSource<<2bc192d20c47db164793b5941c1593c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarDetailsAbout_item$data = {
  readonly condition: {
    readonly state: string | null;
  } | null;
  readonly hasActiveHoldForBuyer?: boolean | null;
  readonly hasPrivateListing: boolean | null;
  readonly isAvailable: boolean | null;
  readonly isListingUnlisted: boolean | null;
  readonly isSold: boolean | null;
  readonly pdpDetailsDisplay: ReadonlyArray<{
    readonly delimiter: string | null;
    readonly detailDisplayName: string | null;
    readonly detailKey: string | null;
    readonly detailValues: ReadonlyArray<{
      readonly browseUrl: string | null;
      readonly detailKey: string | null;
      readonly displayDetails: string | null;
      readonly displayName: string | null;
      readonly skuId: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailRingSize_detailValues">;
    } | null> | null;
  } | null> | null;
  readonly seller: {
    readonly isAccessible: boolean | null;
  } | null;
  readonly seoDescription: string | null;
  readonly serviceId: string | null;
  readonly storyTellingModule: {
    readonly tabs: ReadonlyArray<{
      readonly contentBodyText: string;
      readonly contentHeader: string | null;
      readonly tabTitle: string;
      readonly tabType: string;
      readonly " $fragmentSpreads": FragmentRefs<"PdpSharedStoryTellingShopAllLink_refactor_storyTellingTab">;
    } | null> | null;
  } | null;
  readonly vertical: VerticalType | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailItemInvoice_item" | "usePdpCreatorDetails_item">;
  readonly " $fragmentType": "PdpRespSidebarDetailsAbout_item";
};
export type PdpRespSidebarDetailsAbout_item$key = {
  readonly " $data"?: PdpRespSidebarDetailsAbout_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarDetailsAbout_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "detailKey",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarDetailsAbout_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vertical",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAvailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "seoDescription",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPrivateListing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isListingUnlisted",
      "storageKey": null
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId"
            }
          ],
          "kind": "ScalarField",
          "name": "hasActiveHoldForBuyer",
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemCondition",
      "kind": "LinkedField",
      "name": "condition",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "state",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PdpDetail",
      "kind": "LinkedField",
      "name": "pdpDetailsDisplay",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "delimiter",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "detailDisplayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "detailValues",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "skuId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "browseUrl",
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayDetails",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedDetailRingSize_detailValues"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "shortTitles",
          "value": true
        }
      ],
      "concreteType": "StoryTellingModule",
      "kind": "LinkedField",
      "name": "storyTellingModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoryTellingTab",
          "kind": "LinkedField",
          "name": "tabs",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tabType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tabTitle",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "contentHeader",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "contentBodyText",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedStoryTellingShopAllLink_refactor_storyTellingTab"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "storyTellingModule(shortTitles:true)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePdpCreatorDetails_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailItemInvoice_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "03a3643b229138af00724be10c7cecda";

export default node;
